import { render, staticRenderFns } from "./RoomCard.vue?vue&type=template&id=346d6d3b&"
import script from "./RoomCard.vue?vue&type=script&lang=js&"
export * from "./RoomCard.vue?vue&type=script&lang=js&"
import style0 from "./RoomCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('346d6d3b', component.options)
    } else {
      api.reload('346d6d3b', component.options)
    }
    module.hot.accept("./RoomCard.vue?vue&type=template&id=346d6d3b&", function () {
      api.rerender('346d6d3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RoomCard.vue"
export default component.exports